import { useCallback, useMemo, useState } from "react";

import axios from "axios";

import config from "@/config"

const FONT_URL = 'https://fonts.googleapis.com/css2'
const VARIANTS = 'ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900'

export const fontOption = font => {
  const family = font?.family || ''
  const value = family.replace(/\s+/g, '_')
  const fontFamily = family.replace(/\s+/g, '+')
  const url = `${FONT_URL}?family=${fontFamily}:${VARIANTS}&display=swap`
  return { label: family, value, url }
}

export const fetchFontOptions = async () => {
  const result = await axios.get(`${config.tailwindProcessor}/fonts`)
  return result?.data?.length ? result.data.map(fontOption) : undefined
}

export default function useFont() {
  const [loading, setLoading] = useState(false)
  const [fonts, setFonts] = useState([])

  const fetchFonts = useCallback(async () => {
    try {
      setLoading(true)
      return await fetchFontOptions()
    } catch (error) {
      return;
    } finally {
      setLoading(false)
    }
  }, [])

  const filter = useCallback((term, fonts) => {
    const regex = RegExp(term, 'i')
    return fonts.filter(font => {
      if (regex.test(font.label) || regex.test(font.value)) {
        return font
      }
    })
  }, [])

  const loadFonts = useCallback(async value => {
    if (fonts.length > 0) {
      return filter(value, fonts)
    }

    const options = await fetchFonts()
    if (options) {
      setFonts(options)
      return filter(value, options)
    }
  }, [fonts, filter, fetchFonts])

  return useMemo(() => ({
    loadFonts,
  }), [loadFonts])
}
